var _defs, _text, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1180 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ah",
    viewBox: "0 0 10 10",
    refX: 3,
    refY: 5,
    markerWidth: 2.4,
    markerHeight: 2.4,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#1a4fd1"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 215,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fontSize: 170,
    fill: "#1e2b58"
  }, "PrimePost")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(880 24) scale(0.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.8 223.9 A 185 185 0 0 1 397.7 137.1",
    fill: "none",
    stroke: "#1a4fd1",
    strokeWidth: 34,
    strokeLinecap: "round",
    markerEnd: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 438.2 288.1 A 185 185 0 0 1 114.3 374.9",
    fill: "none",
    stroke: "#1a4fd1",
    strokeWidth: 34,
    strokeLinecap: "round",
    markerEnd: "url(#ah)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 340,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fill: "#1a4fd1"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: 235
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 165
  }, "x")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brandLogo.105b1aba61ef82e4867c57d253487a65.svg";
export { ForwardRef as ReactComponent };